<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div v-if="loading" class="alert alert-info" role="status">Loading...</div>
    <div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

    <div v-if="item" class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>class</td>
            <td>{{ item['class'] }}</td>
          </tr>
          <tr>
            <td>function</td>
            <td>{{ item['function'] }}</td>
          </tr>
          <tr>
            <td>data</td>
            <td>
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col">Field</th>
                  <th scope="col">Old Value</th>
                  <th scope="col">New Value</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value,key) in JSON.parse(item['data'])">
                  <th scope="row">{{ key }}</th>
                  <td>{{ typeof value[0] !=='undefined' && value[0].date ? value[0].date : value[0] }}</td>
                  <td>{{ typeof value[1] !=='undefined' && value[1].date ? value[1].date : value[1] }}</td>
                </tr>
                </tbody>
              </table>

            </td>
          </tr>
          <tr>
            <td>createdAt</td>
            <td>{{ item['createdAt'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link v-if="item" :to="{ name: 'LogList' }" class="btn btn-default">Back to list</router-link>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: mapGetters({
      error: 'log/show/error',
      loading: 'log/show/loading',
      item: 'log/show/item',
    }),
    created () {
      this.$store.dispatch('log/show/retrieve', decodeURIComponent(this.$route.params.id));
    },
    beforeDestroy() {
      this.$store.dispatch('log/show/reset');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/log/Show.vue